import React, { forwardRef } from 'react';
import styled from 'styled-components/macro';
import SearchInput from '../Input/SearchInput';
import Icon from 'components/Input/Icon';
import TooltipControlled from 'components/Tooltip/tooltipControlled';
import utils from 'utils';

const SearchContainer = styled.div<{ isMenuOpen: boolean }>`
  padding: ${({ isMenuOpen }) => (isMenuOpen ? '15px 10px' : '10px 2px')};
  z-index: ${({ theme }) => theme.zIndexPalette.medium};
  display: flex;
  justify-content: ${({ isMenuOpen }) => (isMenuOpen ? 'flex-start' : 'center')};

`;

const IconSearchContainer = styled.div`
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  &:hover {
    cursor: pointer;
    background-color: ${({ theme }) =>
      `${
        theme.colorPalette.isDarkMode
          ? theme.colorPalette.withOpacity(theme.colorPalette.grey.grey9, 0.1)
          : theme.colorPalette.withOpacity(theme.colorPalette.grey.grey5, 0.2)
      }`};
  }
`; 



interface MenuSearchProps {
  isMenuOpen: boolean;
  iconColor: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onIconClick: () => void;
}

const MenuSearch = forwardRef<HTMLInputElement, MenuSearchProps>(
  ({ isMenuOpen, iconColor, onChange, onIconClick }, ref) => {
    const t = utils.intl.useTranslator();
    return (
      <SearchContainer isMenuOpen={isMenuOpen}>
        {!isMenuOpen ? (
          <TooltipControlled content={t('search')} placement="right" trigger="hover" delayShow={400}>
            <IconSearchContainer>
              <Icon icon="search" style={{ color: iconColor }} onClick={onIconClick} />
            </IconSearchContainer>
          </TooltipControlled>
        ) : (
          <SearchInput fullWidth onChange={onChange} ref={ref} isSidebar={true} />
        )}
      </SearchContainer>
    );
  },
);

MenuSearch.displayName = 'MenuSearch';

export default MenuSearch;
